import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Text } from '@carnica/ui-kit';
import { IconSendFilled } from '@carnica/graphics';
import classNames from 'classnames/bind';
import { getCookie } from '@beef/utils';
import { RegionConfirmationWrapper } from "./components/RegionConfirmationWrapper";
import { approveRegion } from "../../api/region";
import { Metric } from "../../metric";
import { EHeaderTheme } from "../../store/slices/layout";
import style from "./styles.pcss";
var MobileRegionIcon = function MobileRegionIcon(params) {
  return /*#__PURE__*/React.createElement(IconSendFilled, _extends({}, params, {
    color: "secondary",
    "data-t-id": "components-Region"
  }));
};
var cn = classNames.bind(style);
export var Region = function Region(_ref) {
  var userRegion = _ref.userRegion,
    isInMenu = _ref.isInMenu,
    headerTheme = _ref.headerTheme,
    toggleRegionModal = _ref.toggleRegionModal,
    onRegionConfirmationShow = _ref.onRegionConfirmationShow,
    onRegionConfirmationClose = _ref.onRegionConfirmationClose;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showConfirmation = _useState2[0],
    setShowConfirmation = _useState2[1];

  // Вызываем колбэк для показа подтверждения, если оно активно
  useEffect(function () {
    if (getCookie('CURRENT_REGION') === userRegion.code) {
      setShowConfirmation(false);
      onRegionConfirmationClose === null || onRegionConfirmationClose === void 0 ? void 0 : onRegionConfirmationClose();
    }
    if (showConfirmation) {
      onRegionConfirmationShow === null || onRegionConfirmationShow === void 0 ? void 0 : onRegionConfirmationShow();
    }
  }, [showConfirmation, onRegionConfirmationShow]);
  var closeRegionConfirmation = useCallback(function () {
    setShowConfirmation(false);
    onRegionConfirmationClose === null || onRegionConfirmationClose === void 0 ? void 0 : onRegionConfirmationClose();
  }, [onRegionConfirmationClose]);
  var handleApprove = useCallback(function () {
    closeRegionConfirmation();
    approveRegion(userRegion);
  }, [userRegion, closeRegionConfirmation]);
  if (isInMenu) return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: "geolocation",
    events: {
      headerMetric: ['handleTopIconClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('menu-button'),
    iconRight: MobileRegionIcon,
    mode: "inline",
    onClick: toggleRegionModal,
    tagName: "a",
    "data-t-id": "components-Region"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('menu-button__title'),
    color: "secondary-invert",
    size: "xs",
    "data-t-id": "components-Region"
  }, userRegion.title)));

  // Убираем условие для мобильного, чтобы RegionConfirmationWrapper всегда рендерился и отрабатывал анимацию выхода
  return /*#__PURE__*/React.createElement(RegionConfirmationWrapper, {
    headerTheme: headerTheme,
    onApproveRegionClick: handleApprove,
    onChangeRegionClick: toggleRegionModal,
    onCloseButtonClick: closeRegionConfirmation,
    showConfirmation: showConfirmation
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: "geolocation",
    events: {
      headerMetric: ['handleTopIconClick']
    },
    mode: "click",
    "data-t-id": "components-Region"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('button', {
      'button--indent': !showConfirmation
    }),
    mode: "inline",
    onClick: toggleRegionModal,
    view: "secondary",
    "data-t-id": "components-Region"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('wrapper', "wrapper--".concat(headerTheme)),
    color: "primary",
    size: showConfirmation ? 'xs' : 18,
    "data-t-id": "components-Region"
  }, /*#__PURE__*/React.createElement(IconSendFilled, {
    className: cn('icon'),
    color: headerTheme === EHeaderTheme.dark ? 'primary-invert' : 'primary',
    size: showConfirmation ? 'xs' : 's',
    "data-t-id": "components-Region"
  }), userRegion.title))));
};